module.exports = __webpack_public_path__ + "static/img/hnq0417.4b0fe35.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hnq0417.jpg
// module id = 3NFl
// module chunks = 0